
import {SEARCH_CUSTOMER_ORDER_NUMBER_REQUEST_SUCCESS} from "./CustomerOrderNumberConstants";

export const searchCustomerOrderNumberRequestSuccess = (customers) => {
    return {
        type: SEARCH_CUSTOMER_ORDER_NUMBER_REQUEST_SUCCESS,
        payload: customers
    }
}


export const searchCustomerOrderNumberRequestFailed = (error) => {
    return {
        type: SEARCH_CUSTOMER_ORDER_NUMBER_REQUEST_SUCCESS,
        payload: error
    }
}
